import { render, staticRenderFns } from "./SalaryReceiptCreate.vue?vue&type=template&id=23f0f81e"
import script from "./SalaryReceiptCreate.vue?vue&type=script&lang=js"
export * from "./SalaryReceiptCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports